import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem("a4a_cookie_consent");
      if (!consent) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem("a4a_cookie_consent", "accepted");
    } catch (e) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[70] p-4 sm:p-6">
      <div className="mx-auto max-w-4xl bg-[#1c1b1a] text-[#e8e3d8] shadow-2xl border border-[#33302b] p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie className="w-6 h-6 text-[#e08a5f] shrink-0 hidden sm:block" strokeWidth={1.6} />
        <p className="text-sm leading-relaxed flex-1">
          {t("cookie.banner")}{" "}
          <Link to="/cookie-policy" className="text-[#e08a5f] underline hover:text-[#f0a37f]">
            {t("cookie.more")}
          </Link>
        </p>
        <button
          onClick={accept}
          className="shrink-0 w-full sm:w-auto bg-[#b5533a] hover:bg-[#a0472f] text-white px-7 py-3 text-sm uppercase tracking-[0.14em] transition-colors"
        >
          {t("cookie.accept")}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
